class ThemeForm extends HTMLElement {
  inputs; form;

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.inputs = this.querySelectorAll('theme-input');
    this.form = this.querySelector('form');

    this.form.addEventListener('submit', (e) => {
      this.onSubmitForm(e);
    });
  }

  onSubmitForm = (e) => {
    var valid = true;
    this.inputs.forEach((input) => {
      valid = valid && input.isValid();
    });

    if(!valid){
      e.preventDefault();
      e.stopPropagation();
    } else {
      window.pageLoader.open();
    }
  };

}
if (!window.customElements.get("theme-form")) {
  window.customElements.define("theme-form", ThemeForm);
}